import * as React from 'react';
import { BaseComponentProps, BaseComponentState, BaseComponent } from '../base/BaseComponent';
import { SecurityData, CMS, HotelBedData } from '../shared/index';
import { getAjaxhelper, momentWrapper } from '../utils/index';
import { Pagination, getHotelSlug } from 'src/core';
export interface MyWishlistProps extends BaseComponentProps {
    lang: string;
    user: SecurityData.ApplicationUser;
    user_login: boolean;
    userAccess: string;
}
export interface MyWishlistState extends BaseComponentState {
    page: number;
    wishlist: CMS.Wishlist[];
    total: number;
    detailShow: 'none' | '';
    detailShowComponent: any;
}

export class MyWishlist extends BaseComponent<MyWishlistProps, MyWishlistState> {

    constructor(props: MyWishlistProps) {
        super(props);
        this.state = {
            page: 1,
            wishlist: [],
            total: 0,
            detailShow: "none",
            detailShowComponent: <span />
        };

    }

    componentDidMount() {
        this.getData();
    }

    getData = () => {
        getAjaxhelper().post("/dynamics/bham-api/account-get-wishlist", {
            page: this.state.page
        }).then(
            d => {
                this.setState({ wishlist: d });
            }
        ).catch(
            err => {
                console.log(err);
            }
        );
    }

    cartClick = (data: CMS.CmsSettlementEnquiry[]) => {
        //
        if (data) {
            let retBody: any[] = [];
            for (let a of data) {
                retBody.push(
                    <tr>
                        <td>
                            Name: {a.name} <br />
                            Emmail: {a.email} <br />
                            Phone: {a.phoneNumber} <br />
                            Address: {a.address}   
                        </td>
                        <td>
                            Name: {a.hotelName} <br /> 
                        </td>
                        <td>
                            {}
                        </td>
                        <td>
                            {}
                        </td>
                    </tr>
                );
    
            }
            let ret = (
                <table className="table ">
                    <thead>
                        <tr>
                            <th>Holder</th>
                            <th>Hotels</th>
                            <th>Book Enquiry</th>
                            <th style={{ minWidth: 70, textAlign: "center" }}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {retBody}
                    </tbody>
                </table>
            );
            this.setState({detailShowComponent: ret, detailShow: "" });
        } 
    }

    hotelsClieck = (data: any[]) => {
        //
        if (data) {
            let retBody: any[] = [];
            let key = 0;
            for (let a of data) {
                key++;
                let ht: HotelBedData.Hotel = JSON.parse(a);
                let hotelSlug = getHotelSlug( ht.name! , ht.code!); 
                retBody.push(
                    <tr key={`xs${key}`}>
                        <td>{ht.name}</td>
                        <td>{ht.address}</td>
                        <td>{ht.description}</td>
                        <td><a href={`/${hotelSlug}`} target="_blank"><i className="fa fa-university"/></a></td>
                    </tr>
                );
            }
            let ret = (
                <table className="table ">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Address</th>
                            <th>description</th>
                            <th style={{ minWidth: 70, textAlign: "center" }}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {retBody}
                    </tbody>
                </table>
            );
            this.setState({detailShowComponent: ret, detailShow: "" });
        } 
    }

    calenderClick = (data: HotelBedData.SearchFilter) => {
        // 
        if (data) {
            //
        }
    }

    closeClick = () => {
        this.setState({detailShow: "none"});
    }
    render() {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }

        let isiBody: any[] = [];
        let kay = 0;
        for (let w of this.state.wishlist) {
            kay++;
            let filter: HotelBedData.SearchFilter = JSON.parse(w.filter!);
            isiBody.push(
                <tr key={`aa${kay}`}>
                    <td><a href={`/wishlist?id=${w.code}`} target="_blank">{w.code}</a></td>
                    <td style={{ textAlign: "center" }}>{momentWrapper(w.createdAt).format("MM-DD-YY")}</td>
                    <td style={{ textAlign: "center" }}>{w.opened}</td>
                    <td style={{ textAlign: "center" }}>{w.uniqueAccount}</td>
                    <td style={{ textAlign: "center" }}>{momentWrapper(filter.stay!.checkIn).format("MM-DD-YY")}</td>
                    <td style={{ textAlign: "center" }}>{momentWrapper(filter.stay!.checkOut).format("MM-DD-YY")}</td>
                    <td>{w.status}</td>
                    <td style={{ minWidth: 70, textAlign: "center" }}>
                        <a key={`cart`} style={{ padding: '0px 2px' }}  onClick={(event) => {event.preventDefault(); this.cartClick(w.oneDolarDeposit!); }}>
                            <i className="fa fa-cart-plus" />
                        </a>
                        <a key={`hotel`} style={{ padding: '0px 2px' }} onClick={(event) => {event.preventDefault(); this.hotelsClieck(JSON.parse(w.rowData!)); }}>
                            <i className="fa fa-hotel" />
                        </a>
                        <a key={`calender`} style={{ padding: '0px 2px' }} onClick={(event) => {event.preventDefault(); this.calenderClick(filter); }}>
                            <i className="fa fa-calendar" />
                        </a>
                    </td>
                </tr>
            );
            isiBody.push(
                <tr style={{ display: this.state.detailShow }}>
                    <td colSpan={7}>
                        {this.state.detailShowComponent}
                    </td>
                    <td>
                    <a style={{ padding: '0px 2px' }} onClick={() => { this.closeClick(); }}>
                            <i className="fa fa-close" />
                        </a>
                    </td>
                </tr>
            );
        }

        return (
            <div style={{ minHeight: 500, marginBottom: 30 }}>
                <div style={{ minHeight: 500, backgroundColor: '#fff', borderRadius: 8, border: '1px #fafafa solid' }}>
                    <table className="table ">
                        <thead>
                            <tr>
                                <th>Code</th>
                                <th>Created</th>
                                <th>Opened Count</th>
                                <th>Unique User</th>
                                <th>Check In</th>
                                <th>Check Out</th>
                                <th>Status</th>
                                <th style={{ minWidth: 70, textAlign: "center" }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isiBody}
                        </tbody>
                    </table>
                    <Pagination pageSize={10} onChangePage={this.onChangePage} page={this.state.page} totalCount={this.state.total} />
                </div>
            </div>

        );
    }

    onChangePage = (page: number) => {
        //
    }
}



// WEBPACK FOOTER //
// ./src/my-account/MyWishlist.tsx